import React from "react";
import clsx from "clsx";
import * as productStyles from "../../../styles/products/product-related-contents.module.scss";
import IconContainer from "../IconContainer";
import { useTranslation } from "react-i18next";
import CkEditor from "../ckeditor/CkEditor";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ProductInfos = ({relatedContent}) => {
	const {t, i18n} = useTranslation();
	const activeLocale = i18n.resolvedLanguage;
	const parseDate = (date) => {
		return (new Date(date).toLocaleDateString(activeLocale, {
			day: "2-digit", month: "long", year: "numeric", timeZone:"CET"
		}))
	}

	const removeStyle = (el) => {
		if (el) {
			return el.replace(/(<([^>]+)>)/ig, '')
		}
		return el
	}

	const getImageAlternativeText = (img) => {
		if(!img) return ''
		let alt = ""
		if (activeLocale === 'en') {
			if (img.getImageAlternativeTextEN) {
				return img.getImageAlternativeTextEN
			}
		} else {
			if (img.getImageAlternativeText) {
				return img.getImageAlternativeText
			}
		}
		return alt
	}

	const getDuration = () => {
		if (relatedContent?.duration?.duration) {
			return `${relatedContent.duration.duration} ${t("product.info.days")}`
		}
		return t('exed.product.sidebar.contact-us')
	}

	const getPrice = () => {
		if (relatedContent?.prices?.lastSessionPrice) {
			return `${relatedContent.prices.lastSessionPrice.toLocaleString(activeLocale, {style:"currency", currency:"EUR", minimumFractionDigits: 0})}`
		}
		return t('exed.product.sidebar.contact-us')
	}
	/*
	if (
		!relatedContent 
		|| (relatedContent.sessions?.length === 0
		&& relatedContent.contacts?.length === 0
		&& !relatedContent.duration?.duration
		&& !relatedContent.prices)
	)
	return (<></>)
	*/
	return (
		<div>
			<div className={productStyles.containerContent}>
					<div className={productStyles.containerCategory}>
						<div className={productStyles.categoryTitleContainer}>
							<IconContainer
								icon="CALENDAR"
								color="RED"
								variant="full"
								noHover
								size={30}
								/>
							<h2 className={productStyles.categoryTitle}>
								{t("product.info.next-sessions")}
							</h2>
						</div>
						<div className={productStyles.containerContentCategory}>
							{relatedContent?.sessions?.length > 0 && 
							<ul>
								{relatedContent.sessions.map((session, index) => (
									<li key={index + "listDateProductInfos"} className={productStyles.liste}>
										<p className={productStyles.titleStart}>
											{parseDate(session.date_begin)}
										</p>
										<p className={productStyles.text}>
											{t(`exed.product.products.place.${session.place}`)}
										</p>
									</li>
								))}
							</ul>
							}
							{relatedContent.sessions.length === 0 &&
								<ul>
									<li className={productStyles.liste} key="no-next-session-date">
									<p className={productStyles.titleStart}>
									{t('exed.product.sidebar.contact-us')}
									</p>
									</li>
								</ul>
							}
							{relatedContent.miscellaneous?.next_deadline && <p className={productStyles.nextApp}>
								{t(`exed.product.products.next-app`)}&nbsp;:<br/>{parseDate(relatedContent.miscellaneous.next_deadline)}
							</p>}
						</div>
					</div>
				<div className={productStyles.containerCategory}>
					<div className={productStyles.categoryTitleContainer}>
						<IconContainer
							icon="CLOCK"
							color="RED"
							variant="full"
							size={30}
						/>
						<h2 className={productStyles.categoryTitle}>
							{t("product.info.duration")}
						</h2>
					</div>
					<div className={productStyles.containerContentCategory}>
						 <p className={productStyles.titleStart}>
							{getDuration()}
						</p>
						<p
							className={productStyles.text}
							dangerouslySetInnerHTML={{
								__html: removeStyle(relatedContent.duration?.comment)
							}}
						/>
					</div>
				</div>
				<div className={productStyles.containerCategory}>
					<div className={productStyles.categoryTitleContainer}>
						<IconContainer
							icon="EURO"
							color="RED"
							variant="full"
							size={30}
						/>
						<h2 className={productStyles.categoryTitle}>
							{t("product.info.fees")}
						</h2>
					</div>
					<div className={productStyles.containerContentCategory}>
						<p className={productStyles.titleStart}>
							{getPrice()}
						</p>
						{relatedContent?.prices?.details && <div className={productStyles.ckeditorContainer}>
							<CkEditor html={relatedContent.prices.details}></CkEditor>
						</div>}
					</div>
				</div>
				{relatedContent.contacts && relatedContent.contacts.length > 0 &&
				<div className={productStyles.containerCategory}>
					<div className={productStyles.categoryTitleContainer}>
						<IconContainer
							icon="MESSAGE"
							color="RED"
							variant="full"
							size={30}
						/>
						<h2 className={productStyles.categoryTitle}>
							{t("product.info.contact")}
						</h2>
					</div>
					<div className={productStyles.containerContentCategory}>
						{relatedContent.contacts.map((c, index) => {
							return (
								<div key={index + "contact-product-info"} className={productStyles.containerContact}>
									<div className={productStyles.containerContactText}>
										<p className={productStyles.titleContact}>
											{c.first_name + " " + c.last_name}
										</p>
										<p className={productStyles.textContact}>
											{c.job}
										</p>
										<p className={productStyles.textContact}>
											{c.phone}
										</p>
										<a href={"mailto:" + c.mail} className={productStyles.contactMail}>
											{t("product.info.mailto")}
										</a>
									</div>
									<GatsbyImage
										loading="eager"
										className={productStyles.image}
										image={getImage(c.picture?.imageFile)}
										alt={getImageAlternativeText(c.picture)}
									/>
								</div>
							)
						})}
					</div>
				</div>
				}
			</div>
			{relatedContent.info_meetings &&
				<div className={clsx(productStyles.containerCategoryInfo, productStyles.containerContent)}>
					<div className={productStyles.categoryTitleContainer}>
						<IconContainer
							icon="CALENDAR"
							color="RED"
							variant="full"
							size={30}
						/>
						<h2 className={productStyles.categoryTitle}>
							{t("product.info.info")}
						</h2>
					</div>
					<div className={clsx(productStyles.ckeditorContainer, productStyles.containerContentCategory)}>
						<CkEditor html={relatedContent.info_meetings}/>
					</div>
				</div>
			}
		</div>
	);
};

export default ProductInfos;
